let clockOffsetMs = 0;

/** Update the offset from a response `Date` header (RFC 7231). Cheap; called on every response. */
export function setClockOffsetFromDateHeader(dateHeader: string | null | undefined): void {
  if (!dateHeader) return;
  const serverMs = Date.parse(dateHeader);
  if (!Number.isNaN(serverMs)) clockOffsetMs = serverMs - Date.now();
}

/** Server-aligned "now" in epoch seconds. Falls back to device time (offset 0) until the first response. */
export function serverNowSeconds(): number {
  return Math.floor((Date.now() + clockOffsetMs) / 1000);
}

export function getClockOffsetMs(): number {
  return clockOffsetMs;
}
